var map = {
	"./bakery-packaging.json": 3448,
	"./bubble-tea.json": 4711,
	"./cake-accessories.json": 1393,
	"./celebration-cake.json": 7733,
	"./cupcake-occasions.json": 3135,
	"./daily-order-cakes.json": 8906,
	"./dairy-drinks.json": 5623,
	"./frozen-foods-accessories.json": 2063,
	"./gateaux-cakes-accessories.json": 8838,
	"./goods-return-sheet.json": 8143,
	"./greeting-cards.json": 1895,
	"./ice-cream.json": 7826,
	"./methai-sweets.json": 5616,
	"./personalised-balloon.json": 7529,
	"./personalised-methai-box.json": 2854,
	"./uniform-cleaning-accessories.json": 9737,
	"./wedding-cake.json": 9985
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2427;